export default __webpack_public_path__ + "static/media/CompleteAppointment.bf5f530e.svg";